import {CARD_TYPES, CREATE_TOKEN_CAPTURE_CONTEXT_USED_TOO_MANY_TIMES} from '../../../consts';
import {createToken, fetchBin} from './cybersource-form.services';

const NO_ERROR = '';

export const expiryDateIsInTheFuture = value => {
    let [month, year] = value.split('/');
    year = 2000 + parseInt(year, 10);
    month = parseInt(month, 10);

    const expiryDate = new Date(year, month);

    return expiryDate > new Date();
};

export const validateExpiryDate = errors => value => {
    if (!value) {
        return errors.required;
    }
    // match: "09/23", "12/99", "01/00" not match: "00/00",  "13/23", "12/999", "123/999"
    if (!/^((0[1-9])|(1[0-2]))\/[0-9]{2}$/i.test(value)) {
        return errors.invalidFormat;
    }
    if (!expiryDateIsInTheFuture(value)) {
        return errors.notInFuture;
    }

    return NO_ERROR;
};

export const validateExpiryMonthAndYear = errors => ({expiryMonth, expiryYear}) => {
    if (!expiryMonth || !expiryYear) {
        return {expiryMonth: errors.required};
    }

    const now = new Date();
    const currentYear = now.getFullYear();
    const currentMonth = now.getMonth() + 1;
    const selectedMonth = parseInt(expiryMonth, 10);
    const selectedYear = parseInt(expiryYear, 10);
    if (currentYear === selectedYear && selectedMonth < currentMonth) {
        return {expiryMonth: errors.notInFuture};
    }

    return {};
};


export const validateMicroformField = errors => data => {
    if (data.empty) {
        return errors.required;
    }

    if (!data.valid) {
        return errors.invalid;
    }

    return NO_ERROR;
};

export const validateWhenBinNotFound = errors => data => {
    if (data.cardType === CARD_TYPES.credit) {
        return {
            number: errors.cardNumber.notDetected.whetherIsCredit
        };
    }

    if (data.cardType === CARD_TYPES.debit) {
        return {
            number: errors.cardNumber.notDetected.whetherIsDebit
        };
    }

    return {};
};

export const validateWhenCardTypeMismatched = errors => data => {
    if (data.cardType === CARD_TYPES.debit) {
        return {
            number: errors.cardNumber.detectionMismatch.selectedDebit
        };
    }

    if (data.cardType === CARD_TYPES.credit) {
        return {
            number: errors.cardNumber.detectionMismatch.selectedCredit
        };
    }

    return {};
};

export const validateToken = errors => data => {
    let result = {};

    const cardNumberError = validateMicroformField(errors.cardNumber)(data.values.number);
    if (cardNumberError) {
        result.number = cardNumberError;
    }

    if (data.expiryDateDropDown.enabled) {
        const expiryMonthAndYearErrors = validateExpiryMonthAndYear(errors.expiryDate)(data.values);

        result = {...result, ...expiryMonthAndYearErrors};
    } else {
        const expiryDateError = validateExpiryDate(errors.expiryDate)(data.values.expiryDate);

        if (expiryDateError) {
            result.expiryDate = expiryDateError;
        }
    }

    const securityCodeError = validateMicroformField(errors.securityCode)(data.values.securityCode);
    if (securityCodeError) {
        result.securityCode = securityCodeError;
    }

    if (Object.keys(result).length > 0 || data.cardType === null) {
        return Promise.resolve(result);
    }

    return createToken(data)
        .then(fetchBin)
        .then(response => {
            if (response.status === 404) {
                return validateWhenBinNotFound(errors)(data);
            }

            return response.json().then(() => validateWhenCardTypeMismatched(errors)(data));
        })
        .catch(err => {
            if (err.reason === CREATE_TOKEN_CAPTURE_CONTEXT_USED_TOO_MANY_TIMES) {
                return {
                    number: errors.cardNumber.captureContextExpired
                };
            }

            throw err;
        });
};
